import { service } from '..';

export const apttusService = {
  save: ( cartInfo ) => {
    if(cartInfo.data.ProductConfigurationData[0].TenderInformation.CallingApplication === "Apttus"){
    return service( "TransactionApttus/saveandsendtoapttus" )
      .post( cartInfo.data ).then(
        response => response
      );
    }
    else{
      return service( "sendToExternal/sfdc" )
      .post( cartInfo.data ).then(
        response => response
      );
    }
  }
}  